interface Props {
  selectedCategory: string
  isSearching: boolean
}

export function shouldRenderCategoriesGrid({ selectedCategory, isSearching }: Props) {
  return !selectedCategory && !isSearching
}
